import { render, staticRenderFns } from "./halopsa-send-contact-widget.vue?vue&type=template&id=7008917a&scoped=true&"
import script from "./halopsa-send-contact-widget.vue?vue&type=script&lang=js&"
export * from "./halopsa-send-contact-widget.vue?vue&type=script&lang=js&"
import style0 from "./halopsa-send-contact-widget.vue?vue&type=style&index=0&id=7008917a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008917a",
  null
  
)

export default component.exports